<template>
  <v-toolbar :color="ui.cardColor">
    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
    <v-toolbar-title :class="ui.textSubheadingBold">
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon> edit </v-icon>
        </v-avatar>
        Open Actions
      </v-chip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <GetRegisterListPage :data="{tag: 'K6', tagd: 'U1.B3', tags: 'U1.B3', size: 'icon'}"/>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
      <v-avatar>
      <v-icon> bar_chart </v-icon>
      </v-avatar>
      {{stats.nb3o}}
    </v-chip>

  </v-toolbar>
</template>

<script>
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getDetail", "getUser", "GetRegisterListPage"]),
    stats() {
      return this.getUserStats;
    }
  },
  components: {
    GetRegisterListPage
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
